<template>
  <v-app :class="{ watermark: isStaging }">
    <app-sidebar
      v-if="$auth.isAuthenticated && $route.name != 'loading'"
      :drawer="drawer"
      :class="{ watermarksm: isStaging }"
    ></app-sidebar>
    <v-main style="padding-top: 0">
      <v-flex grow>
        <!-- <AppStatus v-show="$route.name !== 'home'"></AppStatus> -->
        <router-view></router-view>
      </v-flex>

      <v-footer :fixed="fixed" app elevation="3">
        <v-row align="center">
          <v-card-text>
            &copy;{{ new Date().getFullYear() }}
            <strong>Copyright: vonex.com.au</strong>
          </v-card-text>
        </v-row>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import AppSidebar from "./components/app-sidebar";
export default {
  name: "App",
  components: {
    AppSidebar,
  },
  data: () => ({
    clipped: true,
    fixed: true,
    title: "Vonex",
    drawer: true,
    currentYear: new Date().getFullYear(),
  }),
  computed: {
    isStaging() {
      return (
        process.env.NODE_ENV == "Staging" ||
        process.env.NODE_ENV == "development"
      );
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
.watermark {
  background: url("https://vonex.com.au/vonex/projects/watermark-blck.png")
    repeat !important;
}
.watermarksm {
  background: url("https://vonex.com.au/vonex/projects/watermark-small.png")
    repeat !important;
}
</style>
